import { sdkFactory as wixCalendarV3Event_sdkFactory_events } from './src/calendar-v3-event.frontend';
import { sdkFactory as wixCalendarV3EventsView_sdkFactory_eventViews } from './src/calendar-v3-events-view.frontend';
import { sdkFactory as wixCalendarV3Participation_sdkFactory_participations } from './src/calendar-v3-participation.frontend';
import { sdkFactory as wixCalendarV3Schedule_sdkFactory_schedules } from './src/calendar-v3-schedule.frontend';
import { sdkFactory as wixCalendarV3ScheduleTimeFrame_sdkFactory_scheduleTimeFrames } from './src/calendar-v3-schedule-time-frame.frontend';
export function sdkFactory(args) {
    return {
        events: wixCalendarV3Event_sdkFactory_events(args),
        eventViews: wixCalendarV3EventsView_sdkFactory_eventViews(args),
        participations: wixCalendarV3Participation_sdkFactory_participations(args),
        schedules: wixCalendarV3Schedule_sdkFactory_schedules(args),
        scheduleTimeFrames: wixCalendarV3ScheduleTimeFrame_sdkFactory_scheduleTimeFrames(args),
    };
}
//# sourceMappingURL=index.frontend.js.map